export const getLayouts = () => ({
    'default': {},
});
